<template>
  <div class="row">
    <div class="col s12 m8 l4 offset-m2 offset-l4">
      <div class="card">
        <div class="card-action white">
          <h5 v-if="view == 'login'">Login</h5>
          <h5 v-if="view == 'reset'">Reset Account Password</h5>
          <h5 v-if="view == 'activate'">Activate Account</h5>
        </div>
        <div class="card-content">
          <form id="formLogin" v-if="view == 'login'">
            <div class="row">
              <div class="input-field col s12 m12">
                <input class="phone" type="text" v-model="fields.inputEmail" />
                <label for="email" class="active"
                  >Username or Phone number</label
                >
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m12" v-if="reveal == true">
                <i
                  class="material-icons prefix"
                  @click="visibility"
                  style="cursor: pointer;"
                  >visibility_off</i
                >
                <input id="pass" type="text" v-model="fields.inputPassword" />
                <label for="pass" class="active">Password</label>
              </div>
              <div class="input-field col s12 m12" v-if="reveal == false">
                <i
                  class="material-icons prefix"
                  @click="visibility"
                  style="cursor: pointer;"
                  >visibility</i
                >
                <input
                  id="password"
                  type="password"
                  v-model="fields.inputPassword"
                />
                <label for="password" class="active">Password</label>
              </div>
            </div>
            <div class="form-field">
              <div v-if="loading">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
              <div v-else>
                <div class="row">
                  <div class="col s12 m12">
                    <label
                      style="float: left; cursor: pointer"
                      @click.prevent="view = 'reset'"
                    >
                      <span>Forgot Password? </span>
                    </label>
                  </div>
                </div>
                <button
                  id="loginBtn"
                  class="btn-large waves-effect green darken-2 waves-dark"
                  style="width:100%;"
                  @click.prevent="login()"
                >
                  Login <i class="fa fa-sign-in" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </form>
          <form id="reset" v-if="view == 'reset'">
            <div class="row">
              <div class="input-field col s12 m12">
                <input class="phone" type="text" v-model="username" />
                <label for="email" class="active"
                  >Phone number / Username
                </label>
              </div>
            </div>
            <div class="form-field">
              <div v-if="loading">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
              <div v-else>
                <button
                  id="resetBtn"
                  class="btn-large waves-effect green darken-2 waves-dark"
                  style="width:100%;"
                  @click.prevent="reset()"
                >
                  Reset Password
                </button>
                <br />
                <br />
                <button
                  id="resetBtn"
                  class="btn-large waves-effect indigo darken-4 waves-dark"
                  style="width:100%;"
                  @click.prevent="view = 'login'"
                >
                  <i class="fa fa-arrow-left" aria-hidden="true"></i> Back to
                  Login
                </button>
              </div>
            </div>
          </form>
          <form id="reset" v-if="view == 'activate'">
            <div class="row">
              <div class="alert alert-info" v-if="showMessage">
                {{ message }}
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m12">
                <input class="phone" type="text" v-model="otp" />
                <label for="email" class="active"
                  >Enter OTP sent to you
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col s12 m12">
                <label
                  style="float: left; cursor: pointer"
                  @click.prevent="resendOtp()"
                >
                  <span>Click here to resend OTP?</span>
                </label>
              </div>
            </div>
            <div class="form-field">
              <div v-if="loading">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
              <div v-else>
                <button
                  id="resetBtn"
                  class="btn-large waves-effect green darken-2 waves-dark"
                  style="width:100%;"
                  @click.prevent="activateAccount()"
                >
                  Activate Account
                </button>
                <br />
                <br />
                <button
                  class="btn-large waves-effect indigo darken-4 waves-dark"
                  style="width:100%;"
                  @click.prevent="view = 'login'"
                >
                  <i class="fa fa-arrow-left" aria-hidden="true"></i> Back to
                  Login
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  /* eslint-disable */
  mounted() {
    this.fields.inputEmail = localStorage.getItem('phone') ? localStorage.getItem('phone') : ''
    this.username = localStorage.getItem('phone') ? localStorage.getItem('phone') : ''
    $('.phone').val(this.fields.inputEmail)
  },
  data() {
    return {
      loading: false,
      view: 'login',
      reveal: false,
      fields: {
        relocate: 'login',
        action: 'login'
      },
      payload: {},
      username: '',
      otp: null,
      message: '',
      showMessage: false
    }
  },
  methods: {
    visibility() {
      this.reveal = !this.reveal
    },
    resendOtp() {
      this.loading = true
      this.payload.action = 'resend'
      this.payload.username = this.fields.inputEmail
      this.payload.password = this.fields.inputPassword
      this.payload.passcode = this.hash(this.fields.inputPassword)
      this.axios.post('https://irecharge.com.ng/api/otp/resend.php', this.payload)
      .then(response => {
        if(response.data.status == 0) {
          $('.toast').hide()
          this.showMessage = true
          this.message = response.data.message
          this.loading = false
        } else {
          this.loading = false
          this.showMessage = true
          this.message = response.data.message
        }
      })
      .catch(error => {
        console.log(error)
        $('.toast').hide()
        M.toast({ html: 'Could not send request, check network.', classes: 'error' })
        this.loading = false
      })
    },
    activateAccount() {
      this.loading = true
      this.payload.action = 'activate'
      this.payload.username = this.fields.inputEmail
      this.payload.password = this.fields.inputPassword
      this.payload.otp = this.otp
      this.payload.passcode = this.hash(this.fields.inputPassword)
      this.axios.post('https://irecharge.com.ng/api/otp/activate.php', this.payload)
      .then(response => {
        if(response.data.status == 0) {
          $('.toast').hide()
          this.view = 'login'
          this.showMessage = false
          M.toast({ html: response.data.message, classes: 'info' })
          this.loading = false
        } else {
          this.loading = false
          $('.toast').hide()
          M.toast({ html: response.data.message, classes: 'info' })
        }
      })
      .catch(error => {
        console.log(error)
        $('.toast').hide()
        M.toast({ html: 'Could not send request, check network.', classes: 'error' })
        this.loading = false
      })
    },
    login() {
      if(this.ValidateData()) {
        this.loading = true
        this.reveal = false
        // set form data
        var bodyFormData = new FormData()
        bodyFormData.set('relocate', 'login')
        bodyFormData.set('action', 'login')
        bodyFormData.set('inputEmail', this.fields.inputEmail)
        bodyFormData.set('inputPassword', this.fields.inputPassword)
        this.axios.post('control1.php', bodyFormData)
        .then(response => {
          if(response.data.status == 1 || response.data.status == 100) {
            $('.toast').hide()
            M.toast({ html: response.data.message, classes: 'success' })
            // $('#loginBtn').disabled = true
            // userType 1 = user
            // userType 2 = guest
            localStorage.setItem('phone', response.data.phone)
            localStorage.setItem('userType', 1)
            // Status 1 = Don't show the welcome message
            localStorage.setItem('status', 1)
            localStorage.removeItem('power')
            localStorage.removeItem('airtime')
            localStorage.removeItem('data')
            localStorage.removeItem('tv')
            window.location.assign("profile.php")
          }  else if (response.data.status == 2) {
            this.view = 'activate'
            this.loading = false
            $('.toast').hide()
            M.toast({ html: 'Seems you need to activate your account. Please check your email for an activation message.', classes: 'info' })
          } else {
            this.loading = false
            $('.toast').hide()
            M.toast({ html: response.data.message, classes: 'info' })
          }
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({ html: 'Could not send request, check network.', classes: 'error' })
          this.loading = false
        })
      }
    },
    reset() {
      if(this.ValidateReset()) {
        this.loading = true
        // set form data
        var bodyFormData = new FormData()
        bodyFormData.set('action', 'recover_login_new')
        bodyFormData.set('username', this.username)
        this.axios.post('control1.php', bodyFormData)
        .then(response => {
          if(response.data.status == 0) {
            $('.toast').hide()
            M.toast({ html: response.data.message, classes: 'success' })
            this.view = 'login'
            this.loading = false
          } else {
            this.loading = false
            $('.toast').hide()
            M.toast({ html: response.data.message, classes: 'info' })
          }
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({ html: 'Could not send request, check network.', classes: 'error' })
          this.loading = false
        })
      }
    },
    ValidateData() {
      if (this.fields.inputEmail) {
        if (this.fields.inputPassword) {
          return true
        } else {
          $('.toast').hide()
          M.toast({ html: 'Password field is required!', classes: 'info' })
        }
      } else {
        $('.toast').hide()
        M.toast({ html: 'E-mail / Phone field is required!', classes: 'info' })
      }
    },
    ValidateReset() {
      if (this.username) {
        return true
      } else {
        $('.toast').hide()
        M.toast({ html: 'Field is required!', classes: 'info' })
      }
    },
    hash(ref) {
      let passcode = '123NDSx'
      let encrypted = CryptoJS.HmacSHA512(ref, passcode)
      return encrypted.toString()
    }
  }
}
</script>
<style scoped>
  label {
    font-size: 1rem;
    color: #9e9e9e;
    font-weight: bold;
  }
  .card-content {
    padding: 0px 24px 24px;
  }
  .card .card-action {
    padding: 6px 24px;
  }
  .alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: .25rem;
  }
  .alert-info {
    color: #0c5460;
    background-color: #d1ecf1;
    border-color: #bee5eb;
  }
</style>